var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const AnswerBoxLength = {
    Long: 'LONG',
    Short: 'SHORT'
};
export const AnswerStatus = {
    NotStarted: 'NOT_STARTED',
    NotSubmitted: 'NOT_SUBMITTED',
    Submitted: 'SUBMITTED'
};
export const AnswerType = {
    Stroke: 'STROKE',
    Value: 'VALUE'
};
export const CategoryType = {
    Images: 'HAS_IMAGES',
    Categories: 'HAS_CATEGORIES'
};
export const ConnectionStatus = {
    Healthy: 'HEALTHY',
    Unhealthy: 'UNHEALTHY'
};
export const CorrectStatus = {
    Correct: 'CORRECT',
    PartiallyCorrect: 'PARTIALLY_CORRECT',
    Incorrect: 'INCORRECT',
    AutoCorrect: 'AUTO_CORRECT',
    AutoIncorrect: 'AUTO_INCORRECT'
};
export const ExamResultSubject = {
    Kokugo: 'KOKUGO',
    SansuSugaku: 'SANSU_SUGAKU',
    Eigo: 'EIGO',
    Rika: 'RIKA',
    Shakai: 'SHAKAI'
};
export const ExamStatus = {
    PreDelivery: 'PRE_DELIVERY',
    InDelivery: 'IN_DELIVERY',
    DeliveryFinished: 'DELIVERY_FINISHED'
};
export const ExamSubject = {
    Kokugo: 'KOKUGO',
    Sansu: 'SANSU',
    Eigo: 'EIGO',
    Rika: 'RIKA',
    Shakai: 'SHAKAI',
    ChugakuKokugo: 'CHUGAKU_KOKUGO',
    ChugakuSugaku: 'CHUGAKU_SUGAKU',
    ChugakuEigo: 'CHUGAKU_EIGO'
};
export const ExamType = {
    UnitExamQuestion: 'UNIT_EXAM_QUESTION',
    EntranceExamQuestion: 'ENTRANCE_EXAM_QUESTION',
    TutorialExamQuestion: 'TUTORIAL_EXAM_QUESTION'
};
export const KarteSubject = {
    Kokugo: 'KOKUGO',
    SansuSugaku: 'SANSU_SUGAKU',
    Eigo: 'EIGO',
    Rika: 'RIKA',
    Shakai: 'SHAKAI'
};
export const KeyboardCourse = {
    Basic: 'BASIC',
    Advance: 'ADVANCE'
};
export const Order = {
    Asc: 'ASC',
    Desc: 'DESC'
};
export const Palette = {
    ShortAnswer: 'SHORT_ANSWER',
    MultiChoice: 'MULTI_CHOICE',
    Essay: 'ESSAY'
};
export const SemesterType = {
    TwoSemester: 'TWO_SEMESTER',
    ThreeSemester: 'THREE_SEMESTER'
};
export const SortColumn = {
    Name: 'NAME',
    CreatedDate: 'CREATED_DATE',
    UpdatedDate: 'UPDATED_DATE',
    ReturnedDate: 'RETURNED_DATE',
    StartDateTime: 'START_DATE_TIME'
};
export const StudentDistributableAssignmentService = {
    Note: 'NOTE',
    Programming: 'PROGRAMMING',
    Keyboard: 'KEYBOARD',
    Moral: 'MORAL'
};
export const SubPartLayout = {
    SingleColumn: 'SINGLE_COLUMN',
    SingleRow: 'SINGLE_ROW',
    Wrap: 'WRAP'
};
export const TargetExam = {
    Custom: 'CUSTOM',
    Preset: 'PRESET'
};
export const AuthHolderControllerApiAxiosParamCreator = function (configuration) {
    return {
        authHolderControllerGetUserPoolInfo: (cloudId_1, ...args_1) => __awaiter(this, [cloudId_1, ...args_1], void 0, function* (cloudId, options = {}) {
            assertParamExists('authHolderControllerGetUserPoolInfo', 'cloudId', cloudId);
            const localVarPath = `/v1/auth-holder/user-pool`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cloudId !== undefined) {
                localVarQueryParameter['cloudId'] = cloudId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const AuthHolderControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthHolderControllerApiAxiosParamCreator(configuration);
    return {
        authHolderControllerGetUserPoolInfo(cloudId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authHolderControllerGetUserPoolInfo(cloudId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AuthHolderControllerApi.authHolderControllerGetUserPoolInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const AuthHolderControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthHolderControllerApiFp(configuration);
    return {
        authHolderControllerGetUserPoolInfo(cloudId, options) {
            return localVarFp.authHolderControllerGetUserPoolInfo(cloudId, options).then((request) => request(axios, basePath));
        },
    };
};
export class AuthHolderControllerApi extends BaseAPI {
    authHolderControllerGetUserPoolInfo(cloudId, options) {
        return AuthHolderControllerApiFp(this.configuration).authHolderControllerGetUserPoolInfo(cloudId, options).then((request) => request(this.axios, this.basePath));
    }
}
export const CommonControllerApiAxiosParamCreator = function (configuration) {
    return {
        commonControllerGetMetadata: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/commons/metadata`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const CommonControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = CommonControllerApiAxiosParamCreator(configuration);
    return {
        commonControllerGetMetadata(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.commonControllerGetMetadata(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CommonControllerApi.commonControllerGetMetadata']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const CommonControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CommonControllerApiFp(configuration);
    return {
        commonControllerGetMetadata(options) {
            return localVarFp.commonControllerGetMetadata(options).then((request) => request(axios, basePath));
        },
    };
};
export class CommonControllerApi extends BaseAPI {
    commonControllerGetMetadata(options) {
        return CommonControllerApiFp(this.configuration).commonControllerGetMetadata(options).then((request) => request(this.axios, this.basePath));
    }
}
export const ConfirmControllerApiAxiosParamCreator = function (configuration) {
    return {
        confirmControllerGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/confirm/sse`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        confirmControllerPost: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            assertParamExists('confirmControllerPost', 'body', body);
            const localVarPath = `/v1/confirm/sse`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ConfirmControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfirmControllerApiAxiosParamCreator(configuration);
    return {
        confirmControllerGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmControllerGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfirmControllerApi.confirmControllerGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        confirmControllerPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmControllerPost(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfirmControllerApi.confirmControllerPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const ConfirmControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfirmControllerApiFp(configuration);
    return {
        confirmControllerGet(options) {
            return localVarFp.confirmControllerGet(options).then((request) => request(axios, basePath));
        },
        confirmControllerPost(body, options) {
            return localVarFp.confirmControllerPost(body, options).then((request) => request(axios, basePath));
        },
    };
};
export class ConfirmControllerApi extends BaseAPI {
    confirmControllerGet(options) {
        return ConfirmControllerApiFp(this.configuration).confirmControllerGet(options).then((request) => request(this.axios, this.basePath));
    }
    confirmControllerPost(body, options) {
        return ConfirmControllerApiFp(this.configuration).confirmControllerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
export const ExamControllerApiAxiosParamCreator = function (configuration) {
    return {
        examControllerCloneCustomExams: (customExamCloneDto_1, ...args_1) => __awaiter(this, [customExamCloneDto_1, ...args_1], void 0, function* (customExamCloneDto, options = {}) {
            assertParamExists('examControllerCloneCustomExams', 'customExamCloneDto', customExamCloneDto);
            const localVarPath = `/v1/exams/custom/clone`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(customExamCloneDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerDeleteCustomExams: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerDeleteCustomExams', 'id', id);
            const localVarPath = `/v1/exams/custom/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerDeleteDeliveredExam: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerDeleteDeliveredExam', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerDeleteExaminationResult: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerDeleteExaminationResult', 'id', id);
            const localVarPath = `/v1/exams/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerExportAggregation: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerExportAggregation', 'id', id);
            const localVarPath = `/v1/exams/result/{id}/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetAnswerSheet: (id_1, userId_1, ...args_1) => __awaiter(this, [id_1, userId_1, ...args_1], void 0, function* (id, userId, options = {}) {
            assertParamExists('examControllerGetAnswerSheet', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}/answersheet`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetAvailablePublishers: (subject_1, examType_1, grade_1, query_1, ...args_1) => __awaiter(this, [subject_1, examType_1, grade_1, query_1, ...args_1], void 0, function* (subject, examType, grade, query, options = {}) {
            assertParamExists('examControllerGetAvailablePublishers', 'subject', subject);
            const localVarPath = `/v1/exams/preset/publishers`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }
            if (examType !== undefined) {
                localVarQueryParameter['examType'] = examType;
            }
            if (grade !== undefined) {
                localVarQueryParameter['grade'] = grade;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetCustomExam: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerGetCustomExam', 'id', id);
            const localVarPath = `/v1/exams/custom/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetCustomExams: (order_1, sortColumn_1, limit_1, page_1, onlyMyOwn_1, query_1, ...args_1) => __awaiter(this, [order_1, sortColumn_1, limit_1, page_1, onlyMyOwn_1, query_1, ...args_1], void 0, function* (order, sortColumn, limit, page, onlyMyOwn, query, options = {}) {
            assertParamExists('examControllerGetCustomExams', 'order', order);
            assertParamExists('examControllerGetCustomExams', 'sortColumn', sortColumn);
            const localVarPath = `/v1/exams/custom`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (onlyMyOwn !== undefined) {
                localVarQueryParameter['onlyMyOwn'] = onlyMyOwn;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetDeliveredExam: (id_1, withFraudDetection_1, ...args_1) => __awaiter(this, [id_1, withFraudDetection_1, ...args_1], void 0, function* (id, withFraudDetection, options = {}) {
            assertParamExists('examControllerGetDeliveredExam', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (withFraudDetection !== undefined) {
                localVarQueryParameter['withFraudDetection'] = withFraudDetection;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetDeliveredExamStatus: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerGetDeliveredExamStatus', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetDeliveredExams: (order_1, sortColumn_1, limit_1, page_1, nextToken_1, query_1, fiscalYear_1, onlyMyOwn_1, ...args_1) => __awaiter(this, [order_1, sortColumn_1, limit_1, page_1, nextToken_1, query_1, fiscalYear_1, onlyMyOwn_1, ...args_1], void 0, function* (order, sortColumn, limit, page, nextToken, query, fiscalYear, onlyMyOwn, options = {}) {
            assertParamExists('examControllerGetDeliveredExams', 'order', order);
            assertParamExists('examControllerGetDeliveredExams', 'sortColumn', sortColumn);
            const localVarPath = `/v1/exams/delivered`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (nextToken !== undefined) {
                localVarQueryParameter['nextToken'] = nextToken;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            if (onlyMyOwn !== undefined) {
                localVarQueryParameter['onlyMyOwn'] = onlyMyOwn;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetExaminationResult: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerGetExaminationResult', 'id', id);
            const localVarPath = `/v1/exams/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetExaminationResultList: (order_1, sortColumn_1, limit_1, page_1, onlyMyOwn_1, query_1, fiscalYear_1, ...args_1) => __awaiter(this, [order_1, sortColumn_1, limit_1, page_1, onlyMyOwn_1, query_1, fiscalYear_1, ...args_1], void 0, function* (order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options = {}) {
            assertParamExists('examControllerGetExaminationResultList', 'order', order);
            assertParamExists('examControllerGetExaminationResultList', 'sortColumn', sortColumn);
            const localVarPath = `/v1/exams/result`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (onlyMyOwn !== undefined) {
                localVarQueryParameter['onlyMyOwn'] = onlyMyOwn;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetGenres: (subject_1, publisher_1, ...args_1) => __awaiter(this, [subject_1, publisher_1, ...args_1], void 0, function* (subject, publisher, options = {}) {
            assertParamExists('examControllerGetGenres', 'subject', subject);
            const localVarPath = `/v1/exams/preset/genres`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }
            if (publisher !== undefined) {
                localVarQueryParameter['publisher'] = publisher;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetPresetExam: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerGetPresetExam', 'id', id);
            const localVarPath = `/v1/exams/preset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetPresetExams: (subject_1, examType_1, grade_1, limit_1, page_1, publisher_1, genreId_1, nextToken_1, query_1, ...args_1) => __awaiter(this, [subject_1, examType_1, grade_1, limit_1, page_1, publisher_1, genreId_1, nextToken_1, query_1, ...args_1], void 0, function* (subject, examType, grade, limit, page, publisher, genreId, nextToken, query, options = {}) {
            const localVarPath = `/v1/exams/preset`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }
            if (examType !== undefined) {
                localVarQueryParameter['examType'] = examType;
            }
            if (grade !== undefined) {
                localVarQueryParameter['grade'] = grade;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (publisher !== undefined) {
                localVarQueryParameter['publisher'] = publisher;
            }
            if (genreId !== undefined) {
                localVarQueryParameter['genreId'] = genreId;
            }
            if (nextToken !== undefined) {
                localVarQueryParameter['nextToken'] = nextToken;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerGetStudentExaminationResultList: (subject_1, fiscalYear_1, page_1, limit_1, semesterType_1, ...args_1) => __awaiter(this, [subject_1, fiscalYear_1, page_1, limit_1, semesterType_1, ...args_1], void 0, function* (subject, fiscalYear, page, limit, semesterType, options = {}) {
            assertParamExists('examControllerGetStudentExaminationResultList', 'subject', subject);
            assertParamExists('examControllerGetStudentExaminationResultList', 'fiscalYear', fiscalYear);
            const localVarPath = `/v1/exams/student-result`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (semesterType !== undefined) {
                localVarQueryParameter['semesterType'] = semesterType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostAdditionalTime: (id_1, deliveredExamAdditionalTimeDto_1, ...args_1) => __awaiter(this, [id_1, deliveredExamAdditionalTimeDto_1, ...args_1], void 0, function* (id, deliveredExamAdditionalTimeDto, options = {}) {
            assertParamExists('examControllerPostAdditionalTime', 'id', id);
            assertParamExists('examControllerPostAdditionalTime', 'deliveredExamAdditionalTimeDto', deliveredExamAdditionalTimeDto);
            const localVarPath = `/v1/exams/delivered/{id}/additional-time`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deliveredExamAdditionalTimeDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostAnswerSheet: (id_1, answerSheetSaveDto_1, ...args_1) => __awaiter(this, [id_1, answerSheetSaveDto_1, ...args_1], void 0, function* (id, answerSheetSaveDto, options = {}) {
            assertParamExists('examControllerPostAnswerSheet', 'id', id);
            assertParamExists('examControllerPostAnswerSheet', 'answerSheetSaveDto', answerSheetSaveDto);
            const localVarPath = `/v1/exams/delivered/{id}/answersheet`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(answerSheetSaveDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostBeOver: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerPostBeOver', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}/over`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostCustomExams: (customExamSaveDto_1, ...args_1) => __awaiter(this, [customExamSaveDto_1, ...args_1], void 0, function* (customExamSaveDto, options = {}) {
            assertParamExists('examControllerPostCustomExams', 'customExamSaveDto', customExamSaveDto);
            const localVarPath = `/v1/exams/custom`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(customExamSaveDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostDeliveredExam: (deliveredExamCreateDto_1, ...args_1) => __awaiter(this, [deliveredExamCreateDto_1, ...args_1], void 0, function* (deliveredExamCreateDto, options = {}) {
            assertParamExists('examControllerPostDeliveredExam', 'deliveredExamCreateDto', deliveredExamCreateDto);
            const localVarPath = `/v1/exams/delivered`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deliveredExamCreateDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostDistributeReviewWork: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerPostDistributeReviewWork', 'id', id);
            const localVarPath = `/v1/exams/result/{id}/reviewWork`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostMark: (id_1, markDto_1, ...args_1) => __awaiter(this, [id_1, markDto_1, ...args_1], void 0, function* (id, markDto, options = {}) {
            assertParamExists('examControllerPostMark', 'id', id);
            assertParamExists('examControllerPostMark', 'markDto', markDto);
            const localVarPath = `/v1/exams/result/{id}/mark`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(markDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPostReturn: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerPostReturn', 'id', id);
            const localVarPath = `/v1/exams/result/{id}/return`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPutBeginExam: (id_1, deliveredExamBeginDto_1, ...args_1) => __awaiter(this, [id_1, deliveredExamBeginDto_1, ...args_1], void 0, function* (id, deliveredExamBeginDto, options = {}) {
            assertParamExists('examControllerPutBeginExam', 'id', id);
            assertParamExists('examControllerPutBeginExam', 'deliveredExamBeginDto', deliveredExamBeginDto);
            const localVarPath = `/v1/exams/delivered/{id}/begin`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deliveredExamBeginDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerPutEndExam: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('examControllerPutEndExam', 'id', id);
            const localVarPath = `/v1/exams/delivered/{id}/end`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        examControllerUpdateDeliveredExam: (id_1, deliveredExamUpdateDto_1, ...args_1) => __awaiter(this, [id_1, deliveredExamUpdateDto_1, ...args_1], void 0, function* (id, deliveredExamUpdateDto, options = {}) {
            assertParamExists('examControllerUpdateDeliveredExam', 'id', id);
            assertParamExists('examControllerUpdateDeliveredExam', 'deliveredExamUpdateDto', deliveredExamUpdateDto);
            const localVarPath = `/v1/exams/delivered/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deliveredExamUpdateDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ExamControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExamControllerApiAxiosParamCreator(configuration);
    return {
        examControllerCloneCustomExams(customExamCloneDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerCloneCustomExams(customExamCloneDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerCloneCustomExams']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerDeleteCustomExams(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerDeleteCustomExams(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerDeleteCustomExams']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerDeleteDeliveredExam(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerDeleteDeliveredExam(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerDeleteDeliveredExam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerDeleteExaminationResult(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerDeleteExaminationResult(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerDeleteExaminationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerExportAggregation(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerExportAggregation(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerExportAggregation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetAnswerSheet(id, userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetAnswerSheet(id, userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetAnswerSheet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetAvailablePublishers(subject, examType, grade, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetAvailablePublishers(subject, examType, grade, query, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetAvailablePublishers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetCustomExam(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetCustomExam(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetCustomExam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetCustomExams']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetDeliveredExam(id, withFraudDetection, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetDeliveredExam(id, withFraudDetection, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetDeliveredExam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetDeliveredExamStatus(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetDeliveredExamStatus(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetDeliveredExamStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, onlyMyOwn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, onlyMyOwn, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetDeliveredExams']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetExaminationResult(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetExaminationResult(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetExaminationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetExaminationResultList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetGenres(subject, publisher, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetGenres(subject, publisher, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetGenres']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetPresetExam(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetPresetExam(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetPresetExam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetPresetExams(subject, examType, grade, limit, page, publisher, genreId, nextToken, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetPresetExams(subject, examType, grade, limit, page, publisher, genreId, nextToken, query, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetPresetExams']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerGetStudentExaminationResultList(subject, fiscalYear, page, limit, semesterType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerGetStudentExaminationResultList(subject, fiscalYear, page, limit, semesterType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerGetStudentExaminationResultList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerPostAdditionalTime']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerPostAnswerSheet(id, answerSheetSaveDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostAnswerSheet(id, answerSheetSaveDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerPostAnswerSheet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerPostBeOver(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostBeOver(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerPostBeOver']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerPostCustomExams(customExamSaveDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostCustomExams(customExamSaveDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerPostCustomExams']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerPostDeliveredExam(deliveredExamCreateDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostDeliveredExam(deliveredExamCreateDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerPostDeliveredExam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerPostDistributeReviewWork(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostDistributeReviewWork(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerPostDistributeReviewWork']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerPostMark(id, markDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostMark(id, markDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerPostMark']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerPostReturn(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPostReturn(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerPostReturn']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerPutBeginExam(id, deliveredExamBeginDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPutBeginExam(id, deliveredExamBeginDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerPutBeginExam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerPutEndExam(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerPutEndExam(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerPutEndExam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExamControllerApi.examControllerUpdateDeliveredExam']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const ExamControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExamControllerApiFp(configuration);
    return {
        examControllerCloneCustomExams(customExamCloneDto, options) {
            return localVarFp.examControllerCloneCustomExams(customExamCloneDto, options).then((request) => request(axios, basePath));
        },
        examControllerDeleteCustomExams(id, options) {
            return localVarFp.examControllerDeleteCustomExams(id, options).then((request) => request(axios, basePath));
        },
        examControllerDeleteDeliveredExam(id, options) {
            return localVarFp.examControllerDeleteDeliveredExam(id, options).then((request) => request(axios, basePath));
        },
        examControllerDeleteExaminationResult(id, options) {
            return localVarFp.examControllerDeleteExaminationResult(id, options).then((request) => request(axios, basePath));
        },
        examControllerExportAggregation(id, options) {
            return localVarFp.examControllerExportAggregation(id, options).then((request) => request(axios, basePath));
        },
        examControllerGetAnswerSheet(id, userId, options) {
            return localVarFp.examControllerGetAnswerSheet(id, userId, options).then((request) => request(axios, basePath));
        },
        examControllerGetAvailablePublishers(subject, examType, grade, query, options) {
            return localVarFp.examControllerGetAvailablePublishers(subject, examType, grade, query, options).then((request) => request(axios, basePath));
        },
        examControllerGetCustomExam(id, options) {
            return localVarFp.examControllerGetCustomExam(id, options).then((request) => request(axios, basePath));
        },
        examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options) {
            return localVarFp.examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options).then((request) => request(axios, basePath));
        },
        examControllerGetDeliveredExam(id, withFraudDetection, options) {
            return localVarFp.examControllerGetDeliveredExam(id, withFraudDetection, options).then((request) => request(axios, basePath));
        },
        examControllerGetDeliveredExamStatus(id, options) {
            return localVarFp.examControllerGetDeliveredExamStatus(id, options).then((request) => request(axios, basePath));
        },
        examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, onlyMyOwn, options) {
            return localVarFp.examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, onlyMyOwn, options).then((request) => request(axios, basePath));
        },
        examControllerGetExaminationResult(id, options) {
            return localVarFp.examControllerGetExaminationResult(id, options).then((request) => request(axios, basePath));
        },
        examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options) {
            return localVarFp.examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options).then((request) => request(axios, basePath));
        },
        examControllerGetGenres(subject, publisher, options) {
            return localVarFp.examControllerGetGenres(subject, publisher, options).then((request) => request(axios, basePath));
        },
        examControllerGetPresetExam(id, options) {
            return localVarFp.examControllerGetPresetExam(id, options).then((request) => request(axios, basePath));
        },
        examControllerGetPresetExams(subject, examType, grade, limit, page, publisher, genreId, nextToken, query, options) {
            return localVarFp.examControllerGetPresetExams(subject, examType, grade, limit, page, publisher, genreId, nextToken, query, options).then((request) => request(axios, basePath));
        },
        examControllerGetStudentExaminationResultList(subject, fiscalYear, page, limit, semesterType, options) {
            return localVarFp.examControllerGetStudentExaminationResultList(subject, fiscalYear, page, limit, semesterType, options).then((request) => request(axios, basePath));
        },
        examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options) {
            return localVarFp.examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options).then((request) => request(axios, basePath));
        },
        examControllerPostAnswerSheet(id, answerSheetSaveDto, options) {
            return localVarFp.examControllerPostAnswerSheet(id, answerSheetSaveDto, options).then((request) => request(axios, basePath));
        },
        examControllerPostBeOver(id, options) {
            return localVarFp.examControllerPostBeOver(id, options).then((request) => request(axios, basePath));
        },
        examControllerPostCustomExams(customExamSaveDto, options) {
            return localVarFp.examControllerPostCustomExams(customExamSaveDto, options).then((request) => request(axios, basePath));
        },
        examControllerPostDeliveredExam(deliveredExamCreateDto, options) {
            return localVarFp.examControllerPostDeliveredExam(deliveredExamCreateDto, options).then((request) => request(axios, basePath));
        },
        examControllerPostDistributeReviewWork(id, options) {
            return localVarFp.examControllerPostDistributeReviewWork(id, options).then((request) => request(axios, basePath));
        },
        examControllerPostMark(id, markDto, options) {
            return localVarFp.examControllerPostMark(id, markDto, options).then((request) => request(axios, basePath));
        },
        examControllerPostReturn(id, options) {
            return localVarFp.examControllerPostReturn(id, options).then((request) => request(axios, basePath));
        },
        examControllerPutBeginExam(id, deliveredExamBeginDto, options) {
            return localVarFp.examControllerPutBeginExam(id, deliveredExamBeginDto, options).then((request) => request(axios, basePath));
        },
        examControllerPutEndExam(id, options) {
            return localVarFp.examControllerPutEndExam(id, options).then((request) => request(axios, basePath));
        },
        examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options) {
            return localVarFp.examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};
export class ExamControllerApi extends BaseAPI {
    examControllerCloneCustomExams(customExamCloneDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerCloneCustomExams(customExamCloneDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerDeleteCustomExams(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerDeleteCustomExams(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerDeleteDeliveredExam(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerDeleteDeliveredExam(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerDeleteExaminationResult(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerDeleteExaminationResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerExportAggregation(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerExportAggregation(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetAnswerSheet(id, userId, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetAnswerSheet(id, userId, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetAvailablePublishers(subject, examType, grade, query, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetAvailablePublishers(subject, examType, grade, query, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetCustomExam(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetCustomExam(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetCustomExams(order, sortColumn, limit, page, onlyMyOwn, query, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetDeliveredExam(id, withFraudDetection, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetDeliveredExam(id, withFraudDetection, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetDeliveredExamStatus(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetDeliveredExamStatus(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, onlyMyOwn, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetDeliveredExams(order, sortColumn, limit, page, nextToken, query, fiscalYear, onlyMyOwn, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetExaminationResult(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetExaminationResult(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetExaminationResultList(order, sortColumn, limit, page, onlyMyOwn, query, fiscalYear, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetGenres(subject, publisher, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetGenres(subject, publisher, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetPresetExam(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetPresetExam(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetPresetExams(subject, examType, grade, limit, page, publisher, genreId, nextToken, query, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetPresetExams(subject, examType, grade, limit, page, publisher, genreId, nextToken, query, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerGetStudentExaminationResultList(subject, fiscalYear, page, limit, semesterType, options) {
        return ExamControllerApiFp(this.configuration).examControllerGetStudentExaminationResultList(subject, fiscalYear, page, limit, semesterType, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostAdditionalTime(id, deliveredExamAdditionalTimeDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostAnswerSheet(id, answerSheetSaveDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostAnswerSheet(id, answerSheetSaveDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostBeOver(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostBeOver(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostCustomExams(customExamSaveDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostCustomExams(customExamSaveDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostDeliveredExam(deliveredExamCreateDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostDeliveredExam(deliveredExamCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostDistributeReviewWork(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostDistributeReviewWork(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostMark(id, markDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostMark(id, markDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPostReturn(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerPostReturn(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPutBeginExam(id, deliveredExamBeginDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerPutBeginExam(id, deliveredExamBeginDto, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerPutEndExam(id, options) {
        return ExamControllerApiFp(this.configuration).examControllerPutEndExam(id, options).then((request) => request(this.axios, this.basePath));
    }
    examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options) {
        return ExamControllerApiFp(this.configuration).examControllerUpdateDeliveredExam(id, deliveredExamUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}
export const HealthcheckControllerApiAxiosParamCreator = function (configuration) {
    return {
        healthControllerCheck: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/healthcheck`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const HealthcheckControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = HealthcheckControllerApiAxiosParamCreator(configuration);
    return {
        healthControllerCheck(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.healthControllerCheck(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['HealthcheckControllerApi.healthControllerCheck']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const HealthcheckControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HealthcheckControllerApiFp(configuration);
    return {
        healthControllerCheck(options) {
            return localVarFp.healthControllerCheck(options).then((request) => request(axios, basePath));
        },
    };
};
export class HealthcheckControllerApi extends BaseAPI {
    healthControllerCheck(options) {
        return HealthcheckControllerApiFp(this.configuration).healthControllerCheck(options).then((request) => request(this.axios, this.basePath));
    }
}
export const ImageControllerApiAxiosParamCreator = function (configuration) {
    return {
        imageControllerGetCategory: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('imageControllerGetCategory', 'id', id);
            const localVarPath = `/v1/images/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        imageControllerGetCategoryList: (categoryId_1, limit_1, offset_1, ...args_1) => __awaiter(this, [categoryId_1, limit_1, offset_1, ...args_1], void 0, function* (categoryId, limit, offset, options = {}) {
            assertParamExists('imageControllerGetCategoryList', 'categoryId', categoryId);
            const localVarPath = `/v1/images/categories`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        imageControllerGetImage: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            assertParamExists('imageControllerGetImage', 'id', id);
            const localVarPath = `/v1/images/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        imageControllerGetImageList: (categoryId_1, limit_1, offset_1, ...args_1) => __awaiter(this, [categoryId_1, limit_1, offset_1, ...args_1], void 0, function* (categoryId, limit, offset, options = {}) {
            assertParamExists('imageControllerGetImageList', 'categoryId', categoryId);
            const localVarPath = `/v1/images`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ImageControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ImageControllerApiAxiosParamCreator(configuration);
    return {
        imageControllerGetCategory(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetCategory(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ImageControllerApi.imageControllerGetCategory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        imageControllerGetCategoryList(categoryId, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetCategoryList(categoryId, limit, offset, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ImageControllerApi.imageControllerGetCategoryList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        imageControllerGetImage(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetImage(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ImageControllerApi.imageControllerGetImage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        imageControllerGetImageList(categoryId, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageControllerGetImageList(categoryId, limit, offset, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ImageControllerApi.imageControllerGetImageList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const ImageControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ImageControllerApiFp(configuration);
    return {
        imageControllerGetCategory(id, options) {
            return localVarFp.imageControllerGetCategory(id, options).then((request) => request(axios, basePath));
        },
        imageControllerGetCategoryList(categoryId, limit, offset, options) {
            return localVarFp.imageControllerGetCategoryList(categoryId, limit, offset, options).then((request) => request(axios, basePath));
        },
        imageControllerGetImage(id, options) {
            return localVarFp.imageControllerGetImage(id, options).then((request) => request(axios, basePath));
        },
        imageControllerGetImageList(categoryId, limit, offset, options) {
            return localVarFp.imageControllerGetImageList(categoryId, limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};
export class ImageControllerApi extends BaseAPI {
    imageControllerGetCategory(id, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetCategory(id, options).then((request) => request(this.axios, this.basePath));
    }
    imageControllerGetCategoryList(categoryId, limit, offset, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetCategoryList(categoryId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
    imageControllerGetImage(id, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetImage(id, options).then((request) => request(this.axios, this.basePath));
    }
    imageControllerGetImageList(categoryId, limit, offset, options) {
        return ImageControllerApiFp(this.configuration).imageControllerGetImageList(categoryId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}
export const KarteControllerApiAxiosParamCreator = function (configuration) {
    return {
        karteControllerGetExaminationResult: (id_1, userId_1, fiscalYear_1, subject_1, ...args_1) => __awaiter(this, [id_1, userId_1, fiscalYear_1, subject_1, ...args_1], void 0, function* (id, userId, fiscalYear, subject, options = {}) {
            assertParamExists('karteControllerGetExaminationResult', 'id', id);
            assertParamExists('karteControllerGetExaminationResult', 'userId', userId);
            const localVarPath = `/v1/karte/per-subject/exam-results/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        karteControllerGetKarteBySubject: (userId_1, subject_1, fiscalYear_1, ...args_1) => __awaiter(this, [userId_1, subject_1, fiscalYear_1, ...args_1], void 0, function* (userId, subject, fiscalYear, options = {}) {
            assertParamExists('karteControllerGetKarteBySubject', 'userId', userId);
            assertParamExists('karteControllerGetKarteBySubject', 'subject', subject);
            assertParamExists('karteControllerGetKarteBySubject', 'fiscalYear', fiscalYear);
            const localVarPath = `/v1/karte/per-subject`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        karteControllerGetKarteSummary: (userId_1, fiscalYear_1, semesterType_1, ...args_1) => __awaiter(this, [userId_1, fiscalYear_1, semesterType_1, ...args_1], void 0, function* (userId, fiscalYear, semesterType, options = {}) {
            assertParamExists('karteControllerGetKarteSummary', 'userId', userId);
            assertParamExists('karteControllerGetKarteSummary', 'fiscalYear', fiscalYear);
            const localVarPath = `/v1/karte/summary`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (fiscalYear !== undefined) {
                localVarQueryParameter['fiscalYear'] = fiscalYear;
            }
            if (semesterType !== undefined) {
                localVarQueryParameter['semesterType'] = semesterType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const KarteControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = KarteControllerApiAxiosParamCreator(configuration);
    return {
        karteControllerGetExaminationResult(id, userId, fiscalYear, subject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.karteControllerGetExaminationResult(id, userId, fiscalYear, subject, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['KarteControllerApi.karteControllerGetExaminationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        karteControllerGetKarteBySubject(userId, subject, fiscalYear, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.karteControllerGetKarteBySubject(userId, subject, fiscalYear, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['KarteControllerApi.karteControllerGetKarteBySubject']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        karteControllerGetKarteSummary(userId, fiscalYear, semesterType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.karteControllerGetKarteSummary(userId, fiscalYear, semesterType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['KarteControllerApi.karteControllerGetKarteSummary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const KarteControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = KarteControllerApiFp(configuration);
    return {
        karteControllerGetExaminationResult(id, userId, fiscalYear, subject, options) {
            return localVarFp.karteControllerGetExaminationResult(id, userId, fiscalYear, subject, options).then((request) => request(axios, basePath));
        },
        karteControllerGetKarteBySubject(userId, subject, fiscalYear, options) {
            return localVarFp.karteControllerGetKarteBySubject(userId, subject, fiscalYear, options).then((request) => request(axios, basePath));
        },
        karteControllerGetKarteSummary(userId, fiscalYear, semesterType, options) {
            return localVarFp.karteControllerGetKarteSummary(userId, fiscalYear, semesterType, options).then((request) => request(axios, basePath));
        },
    };
};
export class KarteControllerApi extends BaseAPI {
    karteControllerGetExaminationResult(id, userId, fiscalYear, subject, options) {
        return KarteControllerApiFp(this.configuration).karteControllerGetExaminationResult(id, userId, fiscalYear, subject, options).then((request) => request(this.axios, this.basePath));
    }
    karteControllerGetKarteBySubject(userId, subject, fiscalYear, options) {
        return KarteControllerApiFp(this.configuration).karteControllerGetKarteBySubject(userId, subject, fiscalYear, options).then((request) => request(this.axios, this.basePath));
    }
    karteControllerGetKarteSummary(userId, fiscalYear, semesterType, options) {
        return KarteControllerApiFp(this.configuration).karteControllerGetKarteSummary(userId, fiscalYear, semesterType, options).then((request) => request(this.axios, this.basePath));
    }
}
export const NotificationControllerApiAxiosParamCreator = function (configuration) {
    return {
        notificationControllerGetNotification: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/notifications`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const NotificationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = NotificationControllerApiAxiosParamCreator(configuration);
    return {
        notificationControllerGetNotification(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.notificationControllerGetNotification(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NotificationControllerApi.notificationControllerGetNotification']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const NotificationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NotificationControllerApiFp(configuration);
    return {
        notificationControllerGetNotification(options) {
            return localVarFp.notificationControllerGetNotification(options).then((request) => request(axios, basePath));
        },
    };
};
export class NotificationControllerApi extends BaseAPI {
    notificationControllerGetNotification(options) {
        return NotificationControllerApiFp(this.configuration).notificationControllerGetNotification(options).then((request) => request(this.axios, this.basePath));
    }
}
export const RecognitionControllerApiAxiosParamCreator = function (configuration) {
    return {
        recognitionControllerPostOldRecognize: (recognitionRequestDto_1, ...args_1) => __awaiter(this, [recognitionRequestDto_1, ...args_1], void 0, function* (recognitionRequestDto, options = {}) {
            assertParamExists('recognitionControllerPostOldRecognize', 'recognitionRequestDto', recognitionRequestDto);
            const localVarPath = `/v1/recognitions/rest/handwriting/recognize`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recognitionRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        recognitionControllerPostRecognize: (recognitionRequestDto_1, ...args_1) => __awaiter(this, [recognitionRequestDto_1, ...args_1], void 0, function* (recognitionRequestDto, options = {}) {
            assertParamExists('recognitionControllerPostRecognize', 'recognitionRequestDto', recognitionRequestDto);
            const localVarPath = `/v1/recognitions/recognize`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recognitionRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const RecognitionControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = RecognitionControllerApiAxiosParamCreator(configuration);
    return {
        recognitionControllerPostOldRecognize(recognitionRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.recognitionControllerPostOldRecognize(recognitionRequestDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RecognitionControllerApi.recognitionControllerPostOldRecognize']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        recognitionControllerPostRecognize(recognitionRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.recognitionControllerPostRecognize(recognitionRequestDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RecognitionControllerApi.recognitionControllerPostRecognize']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const RecognitionControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RecognitionControllerApiFp(configuration);
    return {
        recognitionControllerPostOldRecognize(recognitionRequestDto, options) {
            return localVarFp.recognitionControllerPostOldRecognize(recognitionRequestDto, options).then((request) => request(axios, basePath));
        },
        recognitionControllerPostRecognize(recognitionRequestDto, options) {
            return localVarFp.recognitionControllerPostRecognize(recognitionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};
export class RecognitionControllerApi extends BaseAPI {
    recognitionControllerPostOldRecognize(recognitionRequestDto, options) {
        return RecognitionControllerApiFp(this.configuration).recognitionControllerPostOldRecognize(recognitionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    recognitionControllerPostRecognize(recognitionRequestDto, options) {
        return RecognitionControllerApiFp(this.configuration).recognitionControllerPostRecognize(recognitionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}
export const SchoolControllerApiAxiosParamCreator = function (configuration) {
    return {
        schoolControllerGetSchoolOption: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/schools/option`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        schoolControllerPutSchoolOption: (updateSchoolOptionDto_1, ...args_1) => __awaiter(this, [updateSchoolOptionDto_1, ...args_1], void 0, function* (updateSchoolOptionDto, options = {}) {
            assertParamExists('schoolControllerPutSchoolOption', 'updateSchoolOptionDto', updateSchoolOptionDto);
            const localVarPath = `/v1/schools/option`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSchoolOptionDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const SchoolControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SchoolControllerApiAxiosParamCreator(configuration);
    return {
        schoolControllerGetSchoolOption(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schoolControllerGetSchoolOption(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SchoolControllerApi.schoolControllerGetSchoolOption']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        schoolControllerPutSchoolOption(updateSchoolOptionDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schoolControllerPutSchoolOption(updateSchoolOptionDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SchoolControllerApi.schoolControllerPutSchoolOption']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const SchoolControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SchoolControllerApiFp(configuration);
    return {
        schoolControllerGetSchoolOption(options) {
            return localVarFp.schoolControllerGetSchoolOption(options).then((request) => request(axios, basePath));
        },
        schoolControllerPutSchoolOption(updateSchoolOptionDto, options) {
            return localVarFp.schoolControllerPutSchoolOption(updateSchoolOptionDto, options).then((request) => request(axios, basePath));
        },
    };
};
export class SchoolControllerApi extends BaseAPI {
    schoolControllerGetSchoolOption(options) {
        return SchoolControllerApiFp(this.configuration).schoolControllerGetSchoolOption(options).then((request) => request(this.axios, this.basePath));
    }
    schoolControllerPutSchoolOption(updateSchoolOptionDto, options) {
        return SchoolControllerApiFp(this.configuration).schoolControllerPutSchoolOption(updateSchoolOptionDto, options).then((request) => request(this.axios, this.basePath));
    }
}
export const StorageControllerApiAxiosParamCreator = function (configuration) {
    return {
        storageControllerUpload: (file_1, ...args_1) => __awaiter(this, [file_1, ...args_1], void 0, function* (file, options = {}) {
            const localVarPath = `/v1/storages/files/upload`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const StorageControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = StorageControllerApiAxiosParamCreator(configuration);
    return {
        storageControllerUpload(file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.storageControllerUpload(file, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StorageControllerApi.storageControllerUpload']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
export const StorageControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StorageControllerApiFp(configuration);
    return {
        storageControllerUpload(file, options) {
            return localVarFp.storageControllerUpload(file, options).then((request) => request(axios, basePath));
        },
    };
};
export class StorageControllerApi extends BaseAPI {
    storageControllerUpload(file, options) {
        return StorageControllerApiFp(this.configuration).storageControllerUpload(file, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map